import type { DoorGuest } from '../../types/Door';
import type { EDGuest } from '../../types/EventDay';

/** The door's guest record in the shape the overview grid and VIP radar read. */
export function doorGuestToED(g: DoorGuest): EDGuest {
  return {
    id: g.id,
    full_name: g.name,
    checkin_status: g.checked_in ? 'TRUE' : 'FALSE',
    checkin_time: g.checked_in_at ?? undefined,
    table_id: g.table?.id,
    tag_id: g.tags.join(', ') || undefined,
  };
}
